//
//  BlockV AG. Copyright (c) 2018, all rights reserved.
//
//  Licensed under the BlockV SDK License (the "License"); you may not use this file or
//  the BlockV SDK except in compliance with the License accompanying it. Unless
//  required by applicable law or agreed to in writing, the BlockV SDK distributed under
//  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
//  ANY KIND, either express or implied. See the License for the specific language
//  governing permissions and limitations under the License.
//

// This file is used as the entry point when compiling a minified build to be imported via a <script> tag.
// It exposes all classes as global objects.

import Blockv from '../src/client/Blockv'
import Discover from '../src/client/Discover'
import VatomView from './VatomView'
import FaceSelection from './FaceSelection'
import BaseFace from './faces/BaseFace'

window.Blockv = Blockv
window.Discover = Discover
window.VatomView = VatomView
window.FaceSelection = FaceSelection
window.BaseFace = BaseFace
